// Contract Partner form options
// Following DRY principle by centralizing option definitions

/**
 * Get language options with translations
 */
export const getLanguageOptions = (tForms: (key: string) => string) => [
  {
    value: 'de',
    label: tForms('contractPartner.languages.de'),
  },
  {
    value: 'en',
    label: tForms('contractPartner.languages.en'),
  },
  {
    value: 'fr',
    label: tForms('contractPartner.languages.fr'),
  },
  {
    value: 'it',
    label: tForms('contractPartner.languages.it'),
  },
];

/**
 * Get role options with translations
 */
export const getRoleOptions = (tForms: (key: string) => string) => [
  {
    value: 'director',
    label: tForms('contractPartner.roles.director'),
  },
  {
    value: 'manager',
    label: tForms('contractPartner.roles.manager'),
  },
  {
    value: 'representative',
    label: tForms('contractPartner.roles.representative'),
  },
  {
    value: 'contact',
    label: tForms('contractPartner.roles.contact'),
  },
];

/**
 * Get title options with translations
 */
export const getTitleOptions = (tForms: (key: string) => string) => [
  {
    value: 'mr',
    label: tForms('contractPartner.titles.mr'),
  },
  {
    value: 'ms',
    label: tForms('contractPartner.titles.ms'),
  },
  {
    value: 'dr',
    label: tForms('contractPartner.titles.dr'),
  },
  {
    value: 'prof',
    label: tForms('contractPartner.titles.prof'),
  },
];
